// OWNED BY THE CHAT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the CHAT
// work and the rest of the app can be written at the same time without two
// people editing one map.
export const chat = {
  // ── the chat page — core.md §9 ───────────────────────────────────────
  'chat.title': 'Teaching assistant',
  'chat.landing.title': 'Which patient would you like to talk about?',
  'chat.landing.body': 'The assistant knows that patient’s whole record — history, visits, diagnoses and orders.',
  'chat.landing.new': 'New patient',
  'chat.landing.open': 'Chat about {{name}}',
  'chat.sidebar.title': 'Conversations',
  'chat.sidebar.new': 'New conversation',
  'chat.sidebar.today': 'Today',
  'chat.sidebar.yesterday': 'Yesterday',
  'chat.sidebar.last7': 'Last 7 days',
  'chat.sidebar.older': 'Older',
  'chat.sidebar.empty': 'No conversations yet.',
  'chat.sidebar.otherPatient': 'Another patient',
  'chat.sidebar.inVisit': 'Conversations inside visits',
  'chat.sidebar.collapse': 'Hide conversations',
  'chat.sidebar.expand': 'Show conversations',
  'chat.sidebar.menu': 'Conversation actions',
  'chat.sidebar.justNow': 'Just now',
  'chat.sidebar.minutesAgo': '{{count}} min ago',
  'chat.sidebar.hoursAgo': '{{count}} h ago',
  'chat.thread.untitled': 'New conversation',
  'chat.thread.renameTitle': 'Rename conversation',
  'chat.thread.renamePlaceholder': 'Conversation title',
  'chat.thread.renameHelper': 'Leave empty to go back to the automatic title.',
  'chat.thread.renamed': 'Renamed.',
  'chat.thread.deleteTitle': 'Delete this conversation?',
  'chat.thread.deleteBody': 'The questions and answers go with it. The patient stays.',
  'chat.thread.deleted': 'The conversation was deleted.',
  'chat.thread.notFound': 'Conversation not found — starting a new one.',
  'chat.thread.notFoundToast': 'Conversation not found',
  'chat.thread.movedToast': 'The answer was saved in the previous conversation.',
  'chat.header.back': 'Back to the record',
  'chat.header.patient': 'Patient',
  'chat.empty.title': 'Ask about {{name}}',
  'chat.empty.body': 'Every answer is written into this conversation and costs Parseh — the price is shown on the button.',
  'chat.prompts.summary': 'Summarise this record',
  'chat.prompts.differential': 'Walk me through the differential, with reasoning',
  'chat.prompts.keyFinding': 'Which finding matters most, and why?',
  'chat.prompts.nextVisit': 'What should I ask at the next visit?',
  'chat.prompts.summaryOf': 'Summarise {{name}}',
  'chat.prompts.differentialFor': 'Walk me through the differential for “{{complaint}}”, with reasoning',
  'chat.prompts.keyFindingFor': 'In “{{complaint}}”, which finding matters most, and why?',
  'chat.composer.placeholder': 'Ask about this patient…',
  'chat.composer.send': 'Send',
  'chat.composer.stop': 'Stop',
  'chat.composer.thinking': 'Thinking…',
  'chat.composer.counter': '{{count}} / {{max}}',
  'chat.composer.offline': 'Offline',
  'chat.composer.reserved': 'A question cannot start with two underscores.',
  'chat.composer.tooLong': 'A question can be at most 4000 characters.',
  'chat.composer.noCredits': 'Not enough Parseh',
  'chat.message.you': 'You',
  'chat.message.assistant': 'Assistant',
  'chat.message.sending': 'Sending',
  'chat.message.sent': 'Sent',
  'chat.message.failed': 'Not sent',
  'chat.message.retry': 'Retry',
  'chat.message.copy': 'Copy',
  'chat.message.copied': 'Copied',
  'chat.message.regenerate': 'Regenerate',
  'chat.message.thumbsUp': 'Helpful',
  'chat.message.thumbsDown': 'Not helpful',
  'chat.message.older': 'Older messages',
  'chat.message.loadingOlder': 'Loading…',
  'chat.message.typing': 'The assistant is thinking',
  'chat.followUps': 'Ask next',
  'chat.references': 'Cited',
  'chat.confidenceLabel': 'Confidence',
  'chat.confidence.low': 'Low',
  'chat.confidence.medium': 'Medium',
  'chat.confidence.high': 'High',
  'chat.kind.chat': 'Question',
  'chat.kind.differential': 'Differential',
  'chat.kind.interaction': 'Interaction check',
  'chat.kind.soap_suggest': 'SOAP suggestion',
  'chat.kind.order_suggest': 'Order suggestions',
  'chat.error.title': 'Could not load this conversation',
  'chat.noCredits.title': 'Not enough Parseh',
  'chat.noCredits.body': 'Your question is back in the box. Top up and send it again.',
  'chat.noCredits.action': 'Top up',
};

export default chat;
